import {
  BellOutlined,
  LogoutOutlined,
  MenuOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Badge, Dropdown, Grid, Space } from 'antd';
import header_logo from 'assets/image.png'
import { Avatar } from 'components';
import { useSessionContext } from 'features/auth';
import { useNotification } from 'features/Notifications/notification-context';
import { useUserContext } from 'features/users';
import { getUserFullName } from 'features/users/utils';
import { useSideBar } from 'providers/side-bar-provider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES,SideBarMenus } from 'routes/constants';
import { HasPermission } from 'utils/CheckPermissions';

// import
import {
  StyledDropdownIcon,
  StyledHeader,
  StyledLogoWrapper,
  StyledUserInfo,
  StyledUserMenuButton,
} from './header.styles';

const { useBreakpoint } = Grid;

export const Header = () => {
  const { collapsed, toggleCollapsed } = useSideBar();
  const { logOut } = useSessionContext();
  const { user } = useUserContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const avatarSize = 24;

  const { unreadCount } = useNotification();
 
  if (!user) return null;

   const handleClick = () => {
    navigate("/notifications"); // replace with your route
  };

  return (
    <StyledHeader className='app-header'>

      <Space
        role='button'
        aria-controls='sideBar'
        aria-expanded={!collapsed}
        onClick={toggleCollapsed}
        className='app-header-logo-wrapper'
        aria-label={t('sideBar.toggle')}
      >
        <MenuOutlined className='app-header-hamburger-mobile' />
        <StyledLogoWrapper className='logo'>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {/* <LogoSvg width={20} height={20} /> */}
            <img src={header_logo} width={50} height={20}/>
            <span style={{ fontSize: "1rem", fontWeight: 400 }}>Phoenix Admin Portal</span>
          </div>
        </StyledLogoWrapper>
      </Space>
{/* <div style={{ padding: "0 16px", cursor: "pointer" }}>
      <Badge count={unreadCount} overflowCount={99}>
        <BellOutlined style={{ fontSize: 24, color: "#701a1aff" }} />
      </Badge>
    </div> */}
    
      <Space className='app-header-user-wrapper'>
         {HasPermission(SideBarMenus.NOTIFICATIONS, 'view') ? (
           <div className='notifition_num' onClick={handleClick}>
        <Badge count={unreadCount} overflowCount={99} >
        <BellOutlined style={{ fontSize: 20, color: "#FFFFFF" }} />
      </Badge>
       </div>
        ):null}
        
        <Dropdown
          menu={{
            items: [
              {
                key: 'accountSettings',
                label: t('userMenu.accountSettings'),
                icon: <SettingOutlined />,
                onClick: () => navigate(ROUTES.ACCOUNT_SETTINGS),
              },
              {
                key: 'logout',
                label: t('userMenu.logOut'),
                icon: <LogoutOutlined />,
                onClick: logOut,
              },
            ],
          }}
          trigger={['click']}
          // required for keyboard accessibility, see: https://github.com/ant-design/ant-design/issues/21357
          getPopupContainer={(triggerNode) =>
            triggerNode.parentNode as HTMLElement
          }
        >
          <StyledUserMenuButton
            className='app-header-user'
            ghost
            $avatarSize={avatarSize}
            aria-label={t('userMenu.toggle')}
          >
            <Avatar size={avatarSize} className='app-header-avatar' />
            <Space className='app-header-space'>
              <StyledUserInfo ellipsis={{ tooltip: true }}>

                {getUserFullName(user)}
              </StyledUserInfo>
              <StyledUserInfo
                className='app-header-user-role'
                ellipsis={{ tooltip: true }}
              >
                {user.roleType}
              </StyledUserInfo>
            </Space>
            {screens.lg ? (
              <StyledDropdownIcon style={{ marginLeft: '15px' }} />
            ) : null}
          </StyledUserMenuButton>
        </Dropdown>
          
      </Space>
    </StyledHeader>
  );
};
